import { Fragment } from 'react'
import { Tooltip, IconButton } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { useMediaXsDown } from '@derolfgroep/ui-components/src/hooks/useMediaXsDown'
import PropTypes from 'prop-types'
import { Taskssidebar } from '../../icons/appbar'

const useStyles = makeStyles((theme) => ({
  iconButtonIcon: {
    width: theme.spacing(4),
    height: theme.spacing(4),
  },
}))

const TasksSidebarToggle = ({ onClickToggle }) => {
  const { iconButtonIcon } = useStyles()
  const isXsDown = useMediaXsDown()
  const Wrapper = isXsDown ? Fragment : Tooltip
  const tooltipProps = !isXsDown ? { title: 'Taken' } : {}
  return (
    <Wrapper {...tooltipProps}>
      <IconButton data-analytics="tasksSidebarToggle" size="small" aria-label="Zijbalk taken" onClick={onClickToggle}>
        <Taskssidebar className={iconButtonIcon} />
      </IconButton>
    </Wrapper>
  )
}

TasksSidebarToggle.propTypes = {
  onClickToggle: PropTypes.func.isRequired,
}

export default TasksSidebarToggle
